import React from 'react';
import Head from 'next/head';

type Props = {
  title: string;
};

export const NskHead: React.FC<Props> = ({ title }: Props) => (
  <Head>
    <title>{`${title} | 内装工事くん`}</title>
    <link href="/favicon.ico" rel="icon" />
    <meta
      charSet="utf-8"
      content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
      name="viewport"
    />
  </Head>
);
